<template>
  <div class="entry-row">
    <TimePicker v-model="value.start" @input="onTimeChanged"/>
    <div>{{$t('to')}}</div>
    <TimePicker v-model="value.end"   @input="onTimeChanged"/>
    <div>{{ dayDifference ? `+${dayDifference}` : '' }}</div>
    <div style="flex-grow: 1"></div>
    <div>{{ duration }}</div>
    <div class="action" @click="$emit('delete')">
      <svgicon src="icon/close.svg" :height="12" :width="12"></svgicon>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import TimePicker from "@/components/TimePickerAsSelect";

export default {
  name: "TimesheetEntry",
  components: {TimePicker},

  props: {
    value: {
      type: Object,
      required: true
    },
    momentFormat: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss'
    }
  },

  computed: {
    dayDifference() {
      if (!this.value.start || !this.value.end) {
        return null;
      }
      let staMoment = this.toMoment(this.value.start).startOf("day");
      let endMoment = this.toMoment(this.value.end).startOf("day");
      return endMoment.diff(staMoment, 'days');
    },

    duration() {
      if (!this.value.start || !this.value.end) {
        return '--:--';
      }
      let staMoment = this.toMoment(this.value.start);
      let endMoment = this.toMoment(this.value.end);
      let diffInMinutes = endMoment.diff(staMoment, 'minutes');
      let hour = diffInMinutes > 0 ? Math.floor(diffInMinutes / 60) : Math.ceil(diffInMinutes / 60);
      let minute = Math.abs(diffInMinutes % 60);
      return `${hour.toString().padStart(2,'0')}:${minute.toString().padStart(2,'0')}`;
    }
  },

  methods: {
    onTimeChanged() {
      if (!this.value.start || !this.value.end) {
        return;
      }
      let staMoment = this.toMoment(this.value.start);
      let endMoment = this.toMoment(this.value.end);
      let staTime = staMoment.format('HH:mm');
      let endTime = endMoment.format('HH:mm');
      if (staTime <= endTime) {
        endMoment.subtract(this.dayDifference, 'days');
      } else /* endTime < staTime */ {
        endMoment.subtract(this.dayDifference-1, 'days');
      }
      this.value.end = endMoment.format(this.momentFormat);
    },

    toMoment(str) {
      return moment(str, this.momentFormat);
    }
  }
}
</script>

<style lang="scss" scoped>
.entry-row {
  display: flex;
  align-items: center;
  justify-items: center;

  > :not(:last-child) {
    margin-right: 10px;
  }
  .action {
    cursor: pointer;
    width: 20px;
    text-align: center;
    fill: #fc6650;
  }
}
</style>